export type RpcTable = {
    parentFieldName?: string;
    schemaName?: string; // defaults to currentSchema
    tableName: string;
    comment?: string;
    unique?: string[] | string;
    returning?: string[];
    systemTable?: boolean;
};

export enum DataType {
    UUID = 'uuid',
    /**
     * @deprecated хз зачем добавили. Если массив, используйте запись [DataType.UUID]
     * @see IDataType
     */
    UUIDLIST = 'uuid[]',
    VARCHAR = 'character varying',
    DATE = 'date',
    NUMERIC = 'numeric',
    BIGINT = 'bigint',
    BOOLEAN = 'boolean',
    TIMESTAMP = 'timestamp',
    JSON = 'json',
    COMPOSITE = 'composite',
    INTEGER = 'integer',
}

type Aggregations = 'count' | 'sum' | 'avg' | 'min' | 'max' | 'json_agg';

export type ColumnParams = {
    ref?: string;
    /**
     * Добавляет поля в обычный Reference
     * Можно указать либо поле, либо поле и его псевдоним
     */
    include?: (string | [refField: string, alias: string])[];
    comment?: string;
    enumType?: Record<string, { name: string }>;
    columnType?: string;
    numeratorPrefix?: any;
    as?: string;
    fromTable?: string;
    key?: string;
    customType?: string;
    writable?: boolean;
    filterable?: boolean | 'often';
    aggregateWith?: Aggregations | { fn: Aggregations; args?: string[]; partitionBy?: string };
    // ... и так дальше
    // Важно заметить, что нечетные поля должны
    // соответствовать правилу НЕ (№ поля - 1)
};

export type SysDocType = {
    route: string | null;
    doc_type: string | null;
    doc_subtype: string | null;
};

// Типы Документов подключенных к СЭДу
export enum DfDocType {
    INVOICE = 'INVOICE',
    ACT = 'ACT',
    CONTRACT = 'CONTRACT',
    CONTRACT_SERVICE = 'CONTRACT_SERVICE',
    PAYMENT_REGISTER = 'PAYMENT_REGISTER',
    OTHER = 'OTHER',
}

// DfDocTypeName и DfDocTypeOptions вынесены в ./df-doc-type-name.ts
// (они зависят от getIdItem → UserStore → store → config; держим types.ts чистым/lightweight).
